import React from 'react';
import { useSiteContent } from '@/hooks/useSiteContent';
import { trackEvent } from '@/lib/analytics';

function digitsOnly(s) { return (s || '').replace(/[^\d]/g, ''); }

/**
 * Floating WhatsApp + Viber buttons stacked above the Dubi mascot.
 * Auto-hides if numbers not configured. Hidden on /admin (same as chat).
 */
export default function FloatingContacts() {
  const { content } = useSiteContent();
  const wa = digitsOnly(content.whatsapp_number);
  const vb = digitsOnly(content.viber_number);
  if (!wa && !vb) return null;

  const isAdmin = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
  if (isAdmin) return null;

  return (
    <div className="fixed right-6 bottom-56 z-40 flex flex-col gap-3" data-testid="floating-contacts">
      {wa && (
        <a
          href={`https://wa.me/${wa}?text=${encodeURIComponent('Zdravo Dubinko, zanima me dubinsko čišćenje.')}`}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          data-testid="whatsapp-btn"
          onClick={() => trackEvent('click_whatsapp')}
          className="w-12 h-12 rounded-full bg-[#25D366] shadow-xl flex items-center justify-center hover:scale-110 transition"
        >
          <svg viewBox="0 0 32 32" className="w-6 h-6 text-white" fill="currentColor" aria-hidden="true">
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.788 2.723.788.302 0 .53-.087.746-.216.443-.243.888-.63 1.117-1.075.13-.245.203-.517.203-.788 0-.115-.028-.242-.06-.357-.108-.35-1.482-.98-1.982-1.09zM16.552 6.5c-5.02 0-9.106 4.088-9.106 9.107 0 1.62.442 3.164 1.208 4.507L7 24.5l4.526-1.646c1.286.688 2.762 1.09 4.32 1.09 5.02 0 9.106-4.088 9.106-9.107a9.032 9.032 0 0 0-2.667-6.44 8.996 8.996 0 0 0-6.395-2.667z" />
          </svg>
        </a>
      )}
      {vb && (
        <a
          href={`viber://chat?number=%2B${vb}`}
          aria-label="Viber"
          data-testid="viber-btn"
          onClick={() => trackEvent('click_viber')}
          className="w-12 h-12 rounded-full bg-[#665CAC] shadow-xl flex items-center justify-center hover:scale-110 transition"
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor" aria-hidden="true">
            <path d="M20.9 3.8C19.8 2.8 15.4 2.5 12 2.5s-7.8.3-8.9 1.3C2.2 4.7 1.9 6.7 1.8 9.2c0 2.5.2 4.5 1.2 5.5.6.6 1.6 1 3 1.2v3.1l3-3.1c1.1.1 2 .1 3 .1 3.4 0 7.8-.3 8.9-1.3.9-.9 1.2-2.9 1.3-5.4 0-2.5-.3-4.5-1.3-5.5zM12.4 12c-.4-.1-.8-.3-1.1-.5-.4-.3-.9-.7-1.2-1.2-.3-.4-.4-.8-.5-1.1 0-.3.1-.4.3-.5.2-.1.5-.2.6-.2s.2 0 .3.2c.2.3.5.9.6 1s.1.2 0 .3c-.1.1-.2.2-.3.3s-.2.2-.1.4c.1.2.4.6.8 1 .5.4.9.6 1 .6.1 0 .2 0 .3-.1.1-.1.2-.2.3-.3.1-.1.2-.1.3 0 .1.1.8.4 1 .5s.2.2.2.3c0 .1-.1.4-.2.6-.2.3-.6.5-1 .5-.4.1-.7.1-1.3-.3zM17 10.4c0-2.3-1.9-4.2-4.2-4.2v-.6c2.7 0 4.8 2.1 4.8 4.8H17zm-1.4 0c0-1.5-1.3-2.8-2.8-2.8v-.6c1.9 0 3.4 1.5 3.4 3.4h-.6zm-1.4 0c0-.8-.6-1.4-1.4-1.4v-.6c1.1 0 2 .9 2 2h-.6z" />
          </svg>
        </a>
      )}
    </div>
  );
}
